import { isDefined } from './object-utils';

export const isActualSpeciesId = (speciesId: string | undefined): boolean =>
  isDefined(speciesId) && speciesId !== '0';
